import { combineReducers } from "redux"

import dAuth from "reducers/DAuth"
import agreementCards from "reducers/AgreementCards"
import noticeAgreement from "reducers/NoticeAgreement"
import thirdPartyInfo from "reducers/ThirdPartyInfo"
import api from "reducers/Api"
import snackbar from "reducers/Snackbar"
import information from "reducers/Information"
import localeAgreement from "reducers/LocaleAgreement"
import overallAgreements from "reducers/UserAgreementsStatus"

const rootReducer = combineReducers({
  agreementCards,
  api,
  dAuth,
  noticeAgreement,
  snackbar,
  information,
  thirdPartyInfo,
  localeAgreement,
  overallAgreements,
})

export default rootReducer
